export const PARTNER = getServerConstantsValue("PARTNER");
export const APP_VERSION = getServerConstantsValue("APP_VERSION");
export const VIMEO_UPLOAD_TOKEN = getServerConstantsValue("VIMEO_UPLOAD_TOKEN");
export const API_VERSION = 6;